<script setup>
import { ref } from "vue";

defineProps({
  title: { type: String, required: true },
  subtitle: { type: String, default: "" },
  paths: { type: String, default: "" },
});

const emit = defineEmits(["period-change", "date-change"]);

const periods = ["Daily", "Weekly", "Monthly"];
const active = ref("Daily");
const dateRange = ref(null);

function setPeriod(p) {
  active.value = p;
  emit("period-change", p);
}

function onDateChange(val) {
  emit("date-change", val);
}
</script>

<template>
  <header class="an-head">
    <div class="an-head__title">
      <h2>{{ title }}</h2>
      <p v-if="subtitle" class="an-head__subtitle">{{ subtitle }}</p>
      <div v-if="paths" class="an-head__paths">{{ paths }}</div>
    </div>
    <div class="an-head__spacer"></div>
    <div class="an-control">
      <div class="an-datepicker-wrap">
        <VueDatePicker
          v-model="dateRange"
          range
          :multi-calendars="{ solo: true }"
          placeholder="All time"
          :enable-time-picker="false"
          auto-apply
          class="an-datepicker"
          @update:model-value="onDateChange"
        />
      </div>
      <div class="an-seg" role="group" aria-label="Period">
        <button
          v-for="p in periods"
          :key="p"
          type="button"
          :class="{ 'is-active': active === p }"
          @click="setPeriod(p)"
        >
          {{ p }}
        </button>
      </div>
    </div>
  </header>
</template>
